import Vue from 'vue'
import loki from '@azinformatica/loki'
import store from '../commons/store'
import router from '../router'

Vue.use(loki, {store, router})
